import { Route } from "react-router-dom";
import { AboutScreen } from "./AboutScreen";
import { HenrikTestPage } from "./HenrikTestPage";

export const routes = (
  <>
    <Route path="about" Component={AboutScreen} />
    <Route path="about/henrik-test" Component={HenrikTestPage} />
  </>
);
